/**
 * @file_purpose  page for showing meeting scheduled
 * @author Sarmistha Mondal
 * @Date_Created 23/08/2024
 * @Date_Modified
 */

import React, { useState, useEffect } from 'react'
import { useHistory, useParams, useLocation, Link } from 'react-router-dom'
import scheCal from "../../../assets/icons/sche.png"

export default function BookTimeScheduled() {    
    const RAT_WEBSITE_ORIGIN="https://ems.redappletech.com";
    const history = useHistory();
    const location = useLocation();
    let fields;
    fields = location?.state?.date;

    useEffect(() => { window.scrollTo(0, 0) }, [])

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    //     // window.parent.postMessage(window.screen.availHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });

    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, RAT_WEBSITE_ORIGIN);
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });
    return (
        <body style={{ backgroundColor: "#fff" }}>
            <div className="appoinment_hed">
                <div className='sche_cal'>
                    <img src={scheCal} alt='' />
                </div>
                <h4 className='mb-0'>
                    YOU ARE SCHEDULED
                </h4>
                <p className='schedule_para'>
                    A calender invitation has been sent to your email address
                </p>
                <div className='schedule_card_main'>
                    <div class="schedule_card" >
                        <div class="schedule_body">
                            <h5 class="card-title">SCHEDULED DATE & TIME FOR THE MEETING</h5>

                            <div class="card-text">
                                <p><i class="fa-solid fa-user"></i> Red Apple Technologies</p>
                                <p><i class="fa-solid fa-earth-asia"></i> {fields?.timezone_name}</p>
                                <p><i class="fa-solid fa-calendar-days"></i> {fields?.date_time}</p>
                            </div>

                        </div>
                    </div>
                    {/* <div className='schedule_activate'>
                        <button type="button" class="btn btn-danger">Open Invitation</button>
                    </div> */}
                </div>

            </div>
        </body>
    )
}


